import React, { useEffect, useCallback, useRef, useState } from 'react';
import { Divider, Grid, RadioGroup, Radio, FormControlLabel, makeStyles, Typography, TextField, Box, InputAdornment } from "@material-ui/core";
import Botao from "../../../shared/components/Botao";
import Selecao from "../../../shared/components/Selecao";
import { useFormikContext } from 'formik';
import { CODIGO_TECLA_S, CODIGO_TECLA_ESC, LIMITE_CHARS_NUMERO_ETIQUETA_LOTE, codigoTipoLoteNormal, codigoTipoLoteAmostrasEspeciais, codigoDGKPSC } from "../../../shared/utils/Constantes";
import MaskedInput from 'react-text-mask';
import IconeTooltip from '../../../shared/components/IconeTooltip';
import { dadosAcesso } from '../../login/LoginManager'

const DadosCadastroLote = ({
    tiposConservacaoLote,
    disableEmpresas,
    defaultEmpresa,
    empresas,
    empresaSelecionada,
    handleSubmit,
    handleGoBack,
    tiposLote,
    isValid,
    disableConservacoes,
    carregando,
    setIdTipoLoteSelecionado,
    clearTipoLote,
    clearTipoConservacaoLote,
    defaultConservacao,
    setDefaultConservacao,
    editando,
    numeroEtiqueta,
    codigoTipoLote,
    codigoTipoConservacao,
    temperatura,
    possuiImpressora,
    handleChangePossuiImpressora
}) => {
    const classes = useStyles();
    const { values, setFieldValue } = useFormikContext();
    const codigoTipoConservacaoRef = useRef(codigoTipoConservacao);

    const [clienteDGKPSC, setclienteDGKPSC] = useState(false);

    useEffect(() =>{
        if(dadosAcesso?.laboratorio?.captacao === codigoDGKPSC) {
            setclienteDGKPSC(true)
        }
    }, []);

    useEffect(() => {
        const submitShortcut = (event) => {
            if (isValid && event.ctrlKey && event.which === CODIGO_TECLA_S) {
                event.preventDefault();
                handleSubmit(values);
            }
        }

        if (isValid) {
            document.addEventListener('keydown', submitShortcut);
        }
        else {
            document.removeEventListener('keydown', submitShortcut);
        }

        return () => document.removeEventListener('keydown', submitShortcut);
    }, [isValid, handleSubmit, values]);

    useEffect(() => {
        const cancelShortcut = (event) => {
            if (event.which === CODIGO_TECLA_ESC) {
                event.preventDefault();
                handleGoBack();
            }
        }

        document.addEventListener('keydown', cancelShortcut);

        return () => document.removeEventListener('keydown', cancelShortcut);
    }, [handleGoBack]);

    const limparTipoLote = useCallback(() => {
        setFieldValue('tipoLote', '');
    }, [setFieldValue]);

    const limparTipoConservacaoLote = useCallback(() => {
        setFieldValue('tipoConservacaoLote', '');
        setDefaultConservacao('');
        if (codigoTipoConservacaoRef.current) {
            setFieldValue('tipoConservacaoLote', codigoTipoConservacaoRef.current);
            codigoTipoConservacaoRef.current = null;
        }
    }, [setFieldValue, setDefaultConservacao]);

    const atribuirTipoLote = (value) => {
        setIdTipoLoteSelecionado(value.id);
        setFieldValue('tipoLote', value.codigo);
    };

    const handleChangeNumeroEtiqueta = (value) => {
        if (value?.length === LIMITE_CHARS_NUMERO_ETIQUETA_LOTE) {
            var tipoLote = tiposLote.find(c => c.codigo === parseInt(value.substr(5, 1)));
            if (tipoLote) {
                atribuirTipoLote(tipoLote);
            }
        }
        setFieldValue('numeroEtiqueta', value);
    }

    const handleChangeTemperatura = (value) => {
        setFieldValue('temperatura', value);
    }

    const handleChangeRadioPossuiImpressora = (value) => {
        setFieldValue('numeroEtiqueta', null);
        setFieldValue('temperatura', '');
        handleChangePossuiImpressora(value);
    };

    useEffect(() => {
        if (clearTipoLote) {
            limparTipoLote();
        }
        if (clearTipoConservacaoLote) {
            limparTipoConservacaoLote();
        }
    }, [clearTipoLote, clearTipoConservacaoLote, limparTipoLote, limparTipoConservacaoLote]);

    useEffect(() => {
        if (defaultConservacao) {
            setFieldValue('tipoConservacaoLote', defaultConservacao);
        } 
    }, [defaultConservacao, codigoTipoConservacao, setFieldValue])

    useEffect(() => {
        if (numeroEtiqueta) {
            setFieldValue('numeroEtiqueta', numeroEtiqueta);
        }
    }, [numeroEtiqueta, setFieldValue])

    useEffect(() => {
        if (codigoTipoLote || codigoTipoLote === 0) {
            setFieldValue('tipoLote', Number(codigoTipoLote));
        }
    }, [codigoTipoLote, setFieldValue])

    useEffect(() => {
        if (temperatura != null) {
            setFieldValue('temperatura', temperatura);
        }
    }, [temperatura, setFieldValue])

    useEffect(() => {
        if (empresaSelecionada != null) 
            setFieldValue('empresa', empresaSelecionada);
        if (disableEmpresas)
            setFieldValue('empresa', defaultEmpresa);
    }, [setFieldValue, disableEmpresas, defaultEmpresa, empresaSelecionada]);

    const tipoConservacaoSelecionado = values.tipoConservacaoLote && tiposConservacaoLote
        && tiposConservacaoLote.find((c) => c.codigo === values.tipoConservacaoLote);

    const campoTipoLote = (
        <Selecao
            etiqueta="Tipo do lote*"
            codigo={values.tipoLote}
            desativarCampo={numeroEtiqueta != null}
            handleChange={(_, value) => atribuirTipoLote(value)}
            className={classes.input}
            opcoes={tiposLote}
            getOptionLabel={(option) => option.descricao}
            retornarObjetoCompleto={true} 
        />
    );

    return (
        <Grid container>
            <Grid  item xs={9} className="mb-4">
                <Typography variant="h4">
                    Você possui impressora de etiquetas?*
                    
                    <span className="texto-centralizado-vertical ml-2">
                        <IconeTooltip
                            estiloIcone={{ display: "inline"}}
                            title={'*Marque "NÃO" se você recebe as etiquetas pré-impressas ' + 
                                'ou "SIM" se você possui uma impressora de etiquetas.'}
                        />
                    </span>
                </Typography>
            </Grid>

            <Grid item xs={9} className="mb-4">
                <RadioGroup row
                    aria-label="possuiImpressora"
                    name="possuiImpressora" value={possuiImpressora !== null && (possuiImpressora ? "sim" : "nao")}
                    onChange={e => handleChangeRadioPossuiImpressora(e.target.value === "sim")}
                >
                    <FormControlLabel disabled={editando} value="sim" control={<Radio />} label="Sim" />
                    <FormControlLabel className="ml-10" disabled={editando} value="nao" 
                        control={<Radio />} label="Não" />
                </RadioGroup>
            </Grid>
            {(possuiImpressora !== null || editando) &&
                <Grid item container xs={9}>
                    <Grid item xs={6}>
                        <Typography variant="h4" className="mb-4">
                            Dados do lote
                        </Typography>
                    </Grid>
                    
                    <Grid item xs={6} align="right">
                        <Typography className={classes.instrucao}>
                            *Campos obrigatórios
                        </Typography>
                    </Grid>
                
                    <Grid item xs={12} className={"pb-6"}>
                        
                        <Grid container item spacing={3}>
                            {!possuiImpressora ?
                                <Grid item xs={8}>
                                    <TextField
                                        autoFocus
                                        label='Número da etiqueta pré-impressa*'
                                        value={values.numeroEtiqueta}
                                        disabled={numeroEtiqueta != null}
                                        onChange={(event) => handleChangeNumeroEtiqueta(event.target.value)}
                                        className={classes.input}
                                        variant='outlined'
                                        InputProps={{
                                            inputComponent: MascaraNumeroEtiqueta,
                                            classes: {
                                                notchedOutline: classes.notchedOutline
                                            }
                                        }}
                                        InputLabelProps={numeroEtiqueta ? {
                                            shrink: true,
                                            style: {
                                                color: "#61688B"
                                            }
                                        } : {}}                         
                                    />
                                </Grid>

                                :  
                                <Grid item xs={8}>
                                    {campoTipoLote}
                                </Grid>
                            }                            
                            <Grid item xs={4}>
                                <Selecao
                                    etiqueta="Empresa*"
                                    codigo={disableEmpresas ? defaultEmpresa : values.empresa}
                                    value={editando ? empresaSelecionada : ''}
                                    handleChange={(_, value) => setFieldValue('empresa', value)}
                                    className={"largura-maxima"}
                                    opcoes={empresas}
                                    getOptionLabel={(option) => option.descricao}
                                    desativarCampo={disableEmpresas}
                                />
                            </Grid>
                         </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h4" className="mb-4">
                            Conservação do lote
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            {!possuiImpressora &&
                                <Grid item xs={5}>
                                    { campoTipoLote }
                                </Grid>
                            }

                            <Grid item xs={!possuiImpressora ? (4) : (6)}>
                                <Selecao
                                    etiqueta="Conservação do lote*"
                                    codigo={values.tipoConservacaoLote}
                                    handleChange={(_, value) => setFieldValue('tipoConservacaoLote', value)}
                                    className={classes.input}
                                    opcoes={tiposConservacaoLote}
                                    getOptionLabel={(option) => option.descricao}
                                    desativarCampo={disableConservacoes || (editando && (
                                        values.tipoLote === codigoTipoLoteNormal || 
                                        values.tipoLote === codigoTipoLoteAmostrasEspeciais))}
                                />
                            </Grid>

                            <Grid item xs={!possuiImpressora ? (3) : (6)}>
                                <TextField
                                    label="Temp. do lote"
                                    value={values.temperatura}
                                    onChange={(event) => handleChangeTemperatura(event.target.value)}
                                    className={classes.input}
                                    variant='outlined'
                                    type='number'
                                    helperText={tipoConservacaoSelecionado
                                        ? `* mín. ${tipoConservacaoSelecionado.temperaturaMinima}ºC, máx. ${tipoConservacaoSelecionado.temperaturaMaxima}ºC`
                                        : ""}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position='end'>
                                                ºC
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
            <Grid item xs={12} className="rodape-largura-maxima pl-6 pr-6 pb-2">
                <Divider className="mb-3" />
                <Box display="flex" justifyContent="flex-end">
                    <Botao
                        id="cancelar"
                        type="secondary"
                        className={classes.botao + " mr-8"}
                        titulo="Cancelar"
                        atalho="(ESC)"
                        onClick={handleGoBack}
                        carregando={carregando}
                    />
                    <Botao
                        id="salvarSelecionarAmostras"
                        type="primary"
                        className={classes.botao}
                        titulo={editando ? "Salvar alterações" : "Salvar e selecionar amostras"}
                        atalho="(CTRL + S)"
                        onClick={handleSubmit}
                        disabled={!isValid ||
                            ((!values.numeroEtiqueta ||
                                values.numeroEtiqueta.length !== LIMITE_CHARS_NUMERO_ETIQUETA_LOTE)
                                && !possuiImpressora)}
                        carregando={carregando}
                    />
                </Box>
            </Grid>
        </Grid>
    );
}


function MascaraNumeroEtiqueta(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            id="mascaraNumeroEtiqueta"
            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
            guide={false}
            {...other}
        />
    )
}

const useStyles = makeStyles((theme) => ({
    instrucao: {
        fontSize: "14px",
    },
    notchedOutline: {
        borderColor: "#C0C0DE"
    },
    botao: {
        height: "56px",
        width: "325px"
    },
    input: {
        width: "100%",
        '& input:disabled': {
            color: '#23144D',
            backgroundColor: "#ECECF5"
        },
        '& .MuiOutlinedInput-root.Mui-disabled': {
            '& fieldset': {
                borderColor: "#C0C0DE",
            },
        },
    },
}))

export default DadosCadastroLote;
